import { DesignComplexityLogicService } from '@app/logic/design-complexity';
import { IDesignComplexityDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

export abstract class DesignComplexitySelectionBase {
    public designComplexities: IDesignComplexityDto[] = [];
    public fullDesignComplexities: IDesignComplexityDto[] = [];

    protected constructor(
        protected readonly designComplexityLogicService: DesignComplexityLogicService,
    ) {}

    protected loadDesignComplexities(selectedId: number = 0): void {
        this.designComplexityLogicService
            .getDesignComplexitiesForSelection(selectedId)
            .pipe(take(1))
            .subscribe(result => {
                this.fullDesignComplexities = result;
                this.designComplexities = result;
            });
    }
}
